import { connect } from 'react-redux';

import { ObjectsLayout, IObjectsLayoutProps, IObjectOfKP } from './ObjectsLayout';
import { NEW_OBJECTS_KEYS, NEW_OBJECTS_COUNT_KEY } from '../../../interfaces/village';
import { IState } from '../../../store';
import { INewobjectCategorySetSchema, IVillageCounterSetSchema } from '../../../types';
import { getObjectsOnSale } from '../../village_objects/helpers';

export function mapStateToProps(state: IState): IObjectsLayoutProps {
  const { counterSet = {}, newobjectCategorySet, offersSeo, priceMin, priceMax } = state.villageData.village;
  const objects: IObjectOfKP[] = [];
  let total = 0;
  const totalPriceMin = priceMin;
  const totalPriceMax = priceMax;

  const objectsOnSale = getObjectsOnSale(counterSet);

  Object.values(objectsOnSale).forEach(value => {
    total += value;
  });

  Object.values(NEW_OBJECTS_KEYS).forEach(key => {
    const object = newobjectCategorySet && newobjectCategorySet[key as keyof INewobjectCategorySetSchema];

    if (object) {
      const count = counterSet[NEW_OBJECTS_COUNT_KEY[key] as keyof IVillageCounterSetSchema] ?? 0;

      objects.push({
        key,
        object,
        count,
      });
    }
  });

  return {
    objects,
    total,
    totalOnSaleUrl: offersSeo && offersSeo.url,
    totalPriceMin,
    totalPriceMax,
    isCroppedCard: state.isCroppedCard,
  };
}

export const ObjectsLayoutContainer = connect<IObjectsLayoutProps>(mapStateToProps)(ObjectsLayout);
